import * as React from 'react';
import { SerializedStyles } from '@emotion/core';
import ProjectMenu from './sideMenu/ProjectMenu';
import DashboardLayout from '../layout/DashboardLayout';
import { useProjIds } from '../navigation/hooks';


type Props = {
  children: React.ReactNode;
  floatMenu?: boolean;
  className?: string;
  contentStyle?: SerializedStyles;
};


/**
 * ProjectLayout: a component that renders the root layout of project pages with the side menu containing project links
 * and the main content area. Pass your page content as this component's children.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ProjectLayout: React.FC<Props> = props => {
  const projIds = useProjIds();

  return (
    <DashboardLayout {...props} menu={<ProjectMenu />} key={projIds.projDisplayId}>
      {props.children}
    </DashboardLayout>
  );
};


export default ProjectLayout;
